export default "__VITE_ASSET__99d89f32__"